import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import { ComponentDefinition, DateRange } from '../../../models';
import { momentFormat } from '../../../common/';

class SavedRangeModalController implements angular.IComponentController {
    actualComment: string;
    formCtrl: angular.IFormController;
    savedDates: DateRange[];
    timezone: string;

    dates: {
        startDate: moment.Moment;
        endDate: moment.Moment;
    };
    onCancel: () => void;
    onSave: (value: { range: DateRange }) => void;
    range: DateRange;

    readonly format: string;

    private _originalDates: {
        startDate: moment.Moment;
        endDate: moment.Moment;
    };

    static $inject = [];
    
    $onInit() {
        this.dates = this.dates || { startDate: moment(), endDate: moment() };
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['range']) {
            this.init(this.range);
        }
    }

    saveDate() {
        if (this.onSave) {
            this.onSave({
                range: {
                    beginDateTime: this.dates.startDate.format(momentFormat),
                    endDateTime: this.dates.endDate.format(momentFormat),
                    comment: this.actualComment,
                    timeZone: this.timezone,
                    keyword: null,
                    guid: this.range?.guid
                }
            });
        }
        this.init(null);
    }

    cancel() {
        if (this.onCancel) {
            this.onCancel();
        }
    }

    validateComment(): void {
        let isValid = true;
        if (this.formCtrl.actualComment && this.formCtrl.actualComment.$viewValue !== '') {
            isValid = !_.some(this.savedDates, t => t.comment && t.comment.toLowerCase() === this.formCtrl.actualComment.$viewValue.toLowerCase() && t.guid !== this.range?.guid);
        }
        this.formCtrl.actualComment.$setValidity('duplicate', isValid);
    }

    private init(range: DateRange) {
        // #43456 : always use local tz has dates are saved in utc on backend
        this.timezone = moment.tz.guess();
        if (range) {
            this.actualComment = range.comment;
            this._originalDates = this.dates;
            this.dates = {
                startDate: moment(range.beginDateTime),
                endDate: moment(range.endDateTime)
            };
        } else {
            
            this.actualComment = null;
            if (this._originalDates) {
                this.dates = this._originalDates;
            }
        }
    }
}

export const wtSavedRangeModal: ComponentDefinition = {
    componentId: 'wtSavedRangeModal',
    controller: SavedRangeModalController,
    template: require('./savedRangeModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        dates: '<?',
        format: '<?',
        id: '@',
        onCancel: '&?',
        onSave: '&?',
        range: '<',
        savedDates: '<',
    }
};
